import type * as yup from 'yup';

import { kradSchema } from '@/features/Sparten/kradv2/schema/schema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

export const inputSchema = kradSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const useKradv2InputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'Kradv2InputStore',
);
